<template>
<div class="card">
    <loading :active.sync="retrieveLicenseListLoading" 
        :can-cancel="true"
        :is-full-page="false"></loading>
    <div class="card-header d-flex align-items-center justify-content-between device-title">
        <h3>License List</h3> 
    </div> 
    <div class="card-body">
        <div class="d-flex align-items-center mb-3">
            <button type="button" class="btn btn-success flex-grow-0" v-on:click="showLicensePopup()">License 신청</button>
        </div>

        <div class="mb-3">
            <b-form inline @submit.prevent>
                <input type="checkbox" id="expiring" v-model="expiring" @change="reloadRetrieveLicenseList($event)"> &nbsp;
                <label for="expiring"> 만료 즈음 </label> &nbsp;&nbsp;&nbsp;
                <label for="level-list"  class=" mr-2 ml-2">상태</label>
                <b-form-select id="level-list" @change="reloadRetrieveLicenseList($event)" v-model="selectedStatus" :options="statusOptions" size="sm" class="mr-4">
                </b-form-select>
                <label for="keyword"> 검색어 </label> &nbsp;&nbsp;&nbsp; 
                <input class="form-control mb-0" placeholder="keyword" name="keyword" v-model="keyword" @keyup.enter="reloadRetrieveLicenseList"> &nbsp;&nbsp;&nbsp; 
                <button type="button" class="btn btn-success flex-grow-0" v-on:click="reloadRetrieveLicenseList()">Search</button>
            </b-form>
        </div>

        <table class="table table-striped table-bordered table-hover">
            <thead class="">
                <tr class="text-center device-table-header">
                    <th>Serial</th>
                    <th>Alias</th>
                    <th>소속</th>
                    <th>맥 주소</th>
                    <th>만료일</th>
                    <th>상태</th>
                    <th>자세히</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="license in licenseList">  <!-- v-bind:key="license.deviceId" -->
                    <td>{{ license.deviceId }}</td>
                    <td>{{ license.alias }}</td>
                    <td>{{ showOrganization(license.organization, license.tenantId) }}</td>
                    <td>{{ license.macAddress }}</td>
                    <td><div :class="expiringClass(license.to, license.status)">{{ license.to | moment('YYYY-MM-DD') }}</div></td>
                    <td>{{ showLicenseStatus(license.status) }}</td>
                    <td class="text-center">
                    <button type="button" class="btn btn-blue" @click="showLicensePopup(license)">Detail</button>
                    </td>
                </tr>
                <tr v-show="noResult">
                    <td class="text-center" colspan="7">결과가 없습니다.</td>
                </tr>
            </tbody>
        </table>

        <div>
            <button class="btn btn-view-more mx-0" v-on:click="seeMore()" :disabled="licenseList.length == total">더보기 ({{ licenseList.length }} / {{ total }})</button>
        </div>
    </div> <!--card-body-->
    <!--Detail modal start-->
    <b-modal size="lg" ref="modalRequestLicense" header-class="detail-header" title="License Information" ok-only ok-variant="secondary" ok-title="Close"> <!-- size = xl, lg, sm -->
        <table class="table table-striped table-bordered table-hover shadow-sm mt-2">
             <loading :active.sync="requestLicenseLoading" 
                :can-cancel="false" 
                :is-full-page="false"></loading>
                <!-- :loader="dots" 이거 왜 안되지? -->
           <thead class="script-header" >
                <tr class="text-center">
                    <th>Item</th>
                    <th>Value</th>
                    <th>Description</th>
                </tr>
            </thead>
            <tbody>
                <tr v-show="existentLicense">
                    <td>Status</td>
                    <td colspan="2">{{ showLicenseStatus(status) }}</td>
                </tr>
                <tr v-show="existentLicense">
                    <td>Serial</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" name="serial" v-model="deviceId" disabled>
                        </div>
                    </td>
                    <td>Bot의 이름</td>
                </tr>
                <tr>
                    <td>Alias *</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" placeholder="Alias" name="alias" v-model="alias" v-validate="'required'">
                            <div class="alert-danger" v-if="submitted && errors.has('alias')">{{ errors.first('alias') }}</div>
                        </div>
                    </td>
                    <td>Bot의 이름</td>
                </tr>
                <tr>
                    <td>Email</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" placeholder="Email Address" name="email" v-model="email" v-validate="'email'">
                            <div class="alert-danger" v-if="submitted && errors.has('email')">{{ errors.first('email') }}</div>
                        </div>
                    </td>
                    <td>Bot 사용자 이메일 주소</td>
                </tr>
                <tr>
                    <td>Organization</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" placeholder="Organization" name="organization" v-model="organization">
                        </div>
                    </td>
                    <td>소속</td>
                </tr>
                <tr v-if="role === 'Supervisor'">
                    <td>Tenant ID</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" placeholder="Tenant ID" name="tenantId" v-model="tenantId">
                        </div>
                    </td>
                    <td>입력하지 않으면 default 1</td>
                </tr>
                <tr>
                    <td>Mac Address *</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" placeholder="MAC Address" name="macAddress" v-model="macAddress" v-validate="{ required: true, regex: /^([0-9A-F]{2}[-]){5}([0-9A-F]{2})$/ }">
                            <div class="alert-danger" v-if="submitted && errors.has('macAddress')">{{ errors.first('macAddress') }}</div>
                        </div>
                    </td>
                    <td>ex) 50-5B-76-C1-3A-DF</td>
                </tr>
                <tr>
                    <td>From *</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" placeholder="Date" name="from" v-model="from" v-validate="'required|date_format:yyyy-MM-dd'">
                            <div class="alert-danger" v-if="submitted && errors.has('from')">{{ errors.first('from') }}</div>
                        </div>
                    </td>
                    <td>License 시작일</td>
                </tr>
                <tr>
                    <td>To *</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" placeholder="Date" name="to" v-model="to" v-validate="'required|date_format:yyyy-MM-dd'">
                            <div class="alert-danger" v-if="submitted && errors.has('to')">{{ errors.first('to') }}</div>
                        </div>
                    </td>
                    <td>License 만료일 ex) 2020-12-31</td>
                </tr>
                <tr>
                    <td>Reason *</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <textarea class="form-control" rows="3" maxlength="512" placeholder="Reason" name="reason" v-model="reason" v-validate="'required'" />
                            <div class="alert-danger" v-if="submitted && errors.has('reason')">{{ errors.first('reason') }}</div>
                        </div>
                    </td>
                    <td>신청/갱신 이유</td>
                </tr>            
            </tbody>
        </table>
        <div class="text-center pb-2">
            <button type="button" class="btn btn-success" v-on:click="requestLicense()">{{ existentLicense ? 'Update' : 'Submit' }}</button>
            &nbsp;&nbsp;&nbsp;
            <button v-show="existentLicense == false" type="button" class="btn btn-danger" v-on:click="resetRequestForm()">Reset</button>
            <button v-show="existentLicense == true" type="button" class="btn btn-danger" v-on:click="deleteLicense()">Delete</button>
        </div>
    </b-modal>
    <!--Detail modal end -->
<!--Message Modal-->
    <b-modal id="messageModal" header-class="fail-header" title="Message" ok-only ok-variant="secondary" ok-title="Close">
        <p class="my-4 text-center">{{ msgContent }}</p>
    </b-modal>   
</div> <!--card-->   

</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'License',
    data() {
        return {
            licenseList: [],  // retrieveLicenseList의 결과
            total: 0,  // 이 화면의 검색 조건에 맞는 WorkMan에 있는 license의 총 개수

            smallestSerial: -1,  // 더보기 할 때 사용하는 기준점
            expiring: false,  // 만료 즈음 checkbox
            selectedStatus: -1, 
            statusOptions: [
                { value: -1, text: '전체' },
                { value: 1, text: '승인 완료' },
                { value: 0, text: '신청중' },
                { value: 3, text: '갱신중' },
                { value: 2, text: '거절' },
                { value: 9, text: '만료' }
            ], 
            keyword: '',

            noResult: false,  // retrieveLicenseList 에서 결과가 없으면 noResult를 true로 만들어서 결과 없음을 보여줌

            existentLicense: false,  // 이미 있는 License 여부 (있으면 수정/삭제가 가능, 없으면 신규 요청이 가능)

            // 아래 serial부터 reason 까지는 License 하나의 정보인데.. 그냥 객체로 할 걸 그랬나 ;;
            serial: -1,
            status: '', // 신청 시에는 사용하지 않음
            deviceId: '',  // 신청 시에는 사용하지 않음
            alias: '',
            email: '',
            organization: '',
            tenantId: '',
            macAddress: '',
            from: '',
            to: '',
            reason: '',

            submitted: false,  // true가 되면 validate 를 진행함
            retrieveLicenseListLoading: false,  // 라이센스 리스트를 보여주는 곳의 로딩바
            requestLicenseLoading: false,  // 라이센스 신청 폼에서 보여주는 로딩바
            msgStatus: '',  // alert popup 의 status 인데 사용하진 않고, 아래 content는 보여줌
            msgContent: ''
        }
    },
    components: {
        Loading
    },
    computed: {
        deviceList: function() {
            return this.$store.getters.getPeonList;
        },
        role() {
            let user = JSON.parse(localStorage.getItem('user'));

            if (user && user.role) {
                return user.role;
            } else {
                return '';
            }
        }
    },
    // filters: {
    //     formatDate: function(value) {
    //         if (value) {  // 왜 안되는지 원..
    //             return this.$moment(String(value)).format('yyyy-MM-dd');
    //         }
    //     }   
    // },
    methods: {
        showMessage(status, message) {
            this.msgStatus = status;
            this.msgContent = message;
            
            this.$bvModal.show('messageModal');
        },
        showLicensePopup(license) {
            if (license == null) {
                this.existentLicense = false;

                this.serial = -1;
                this.status = '';
                this.deviceId = '';
                this.alias = '';
                this.email = '';
                this.organization = '';
                this.tenantId = '';
                this.macAddress = '';
                this.from = '';
                this.to = '';
                this.reason = '';
            } else {
                this.existentLicense = true;

                this.serial = license.serial;
                this.status = license.status;
                this.deviceId = license.deviceId;
                this.alias = license.alias;
                this.email = license.email;
                this.organization = license.organization;
                this.tenantId = license.tenantId;
                this.macAddress = license.macAddress;
                this.from = license.from && license.from.length >= 10 ? this.$moment(license.from).format('YYYY-MM-DD') : '';
                this.to = license.to && license.to.length >= 10 ? license.to.substring(0, 10) : ''; // this.$moment도 되고 substring도 되고 ;;
                this.reason = license.reason;
            }

            // this.$bvModal.show('modalRequestLicense');
            this.$refs['modalRequestLicense'].show();
        },
        showOrganization(organization, tenantId) {
            if (tenantId == null || tenantId == '1') {
                return organization;
            } else {
                return organization + ' (' + tenantId + ')';
            }
        },
        showLicenseStatus(status) {
            switch (status) {
                case 0: return "신청중";
                case 1: return "유효";
                case 2: return "거절";
                case 3: return "갱신중";
                case 9: return "만료";
                default: return "Unknown";
            }
        },
        expiringClass(toDate, status) {
            if (status == 0 || status == 1 || status == 3) {
                var expired = new Date(toDate);
                var nextMonth = new Date();
                nextMonth.setMonth(nextMonth.getMonth() + 1);

                if (nextMonth > expired) {
                    return "text-major";
                }
            }

            return "text-normal";
        },
        resetRequestForm() {
            this.alias = '';
            this.email = '';
            this.organization = '';
            this.tenantId = '';
            this.macAddress = '';
            this.from = '';
            this.to = '';
            this.reason = '';

            this.submitted = false;
        },
        seeMore() {
            if (this.licenseList && this.licenseList.length > 0) {
                this.smallestSerial = this.licenseList[this.licenseList.length - 1].serial; 
            }

            this.retrieveLicenseList();
        },
        reloadRetrieveLicenseList() {
            this.smallestSerial = -1;
            this.licenseList = [];

            this.retrieveLicenseList();
        },
        retrieveLicenseList() {
            this.retrieveLicenseListLoading = true;
           
            var params = {};

            if (this.smallestSerial > 0) {
                params.serial = this.smallestSerial;
            }

            if (this.expiring == true) {
                var nextMonth = new Date();
                nextMonth.setMonth(nextMonth.getMonth() + 1);
                
                params.to = this.$moment(nextMonth).format('YYYY-MM-DD');
            }

            if (this.selectedStatus != -1) {
                params.status = this.selectedStatus;
            }

            if (this.keyword.trim().length > 0) {
                params.keyword = this.keyword;
            }

            axios.post('peon/retrieveLicenseList', params, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                this.submitted = false;

                response.data.body.list.forEach((item, index, array) => {
                    this.licenseList.push(item);
                });

                this.total = response.data.body.total;
                this.noResult = this.total == 0 ? true : false;
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.retrieveLicenseListLoading = false;
            });
        },
        requestLicense() {
            this.submitted = true;

            this.$validator.validate().then(valid => {
                if (valid) {
                    this.requestLicenseLoading = true;
                   
                    var params = {
                        'alias': this.alias.trim(),
                        'email': this.email ? this.email.trim() : '',
                        'organization': this.organization ? this.organization.trim() : '',
                        'tenantId': this.tenantId ? this.tenantId.trim() : '',
                        'macAddress': this.macAddress.trim(),
                        'from': this.from.trim(),
                        'to': this.to.trim(),
                        'reason': this.reason
                    };

                    if (this.existentLicense) {
                        params.serial = this.serial;
                    }

                    var api = this.existentLicense ? 'peon/updateLicense' : 'peon/requestLicense';

                    axios.post(api, params, {
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': accessToken()
                        }
                    }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                        this.submitted = false;

                        this.reloadRetrieveLicenseList();

                        if (this.existentLicense) {
                            this.$refs['modalRequestLicense'].hide();
                        }

                        this.showMessage(0, "License 신청이 완료되었습니다.");
                    }).catch(error => {
                        if (error.status != 401) {
                            this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                        }
                    }).finally(() => {
                        this.requestLicenseLoading = false;
                    });
                }
            });
        },
        deleteLicense() {
            this.submitted = false;

            // loading 이름이 좀 그렇지만, 이대로 재활용..
            this.requestLicenseLoading = true;
           
            var params = {
                'serial': this.serial
            };

            axios.get('peon/deleteLicense', {
                params: params,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                this.reloadRetrieveLicenseList();

                this.$refs['modalRequestLicense'].hide();

                this.showMessage(0, "License 삭제가 완료되었습니다.");
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.requestLicenseLoading = false;
            });
        }
    },
    created() {
        this.retrieveLicenseList();
        // this.$store.dispatch('retrievePeonList'); 
    }
}

// function toDateString(date) {
//     var year = date.getFullYear();
//     var month = (1 + date.getMonth());
//     month = month >= 10 ? month : '0' + month;
//     var day = date.getDate();
//     day = day >= 10 ? day : '0' + day;

//     return year + '-' + month + '-' + day;
// }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
